import { isUndefined } from 'lodash';

import H from 'constants/httpMethod.const';
import { AUTH_API } from 'middleware/api';
import authenticatedEndpoint from 'utils/backend/authenticatedEndpoint.util';
import jsonEndpoint from 'utils/backend/jsonEndpoint.util';
import fromAnyToCoinNum from 'utils/converters/any/fromAnyToCoinNum.util';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import logger from 'utils/logger.util';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';
import { isNotValidId } from 'utils/predicates/fields.util';
import replaceNaN from 'utils/values/replaceNaN.util';

const L = logger('beChargeCardOnFile'); // eslint-disable-line no-unused-vars

export const CHARGE_NOSHOW_REQUEST = 'CHARGE_NOSHOW_REQUEST';
export const CHARGE_NOSHOW_SUCCESS = 'CHARGE_NOSHOW_SUCCESS';
export const CHARGE_NOSHOW_FAILURE = 'CHARGE_NOSHOW_FAILURE';

export const CHARGE_CARD_ONFILE_REQUEST = 'CHARGE_CARD_ONFILE_REQUEST';
export const CHARGE_CARD_ONFILE_SUCCESS = 'CHARGE_CARD_ONFILE_SUCCESS';
export const CHARGE_CARD_ONFILE_FAILURE = 'CHARGE_CARD_ONFILE_FAILURE';

const DEPO_TYPES = Object.freeze([CHARGE_NOSHOW_REQUEST, CHARGE_NOSHOW_SUCCESS, CHARGE_NOSHOW_FAILURE]);
const CARD_TYPES = Object.freeze([CHARGE_CARD_ONFILE_REQUEST, CHARGE_CARD_ONFILE_SUCCESS, CHARGE_CARD_ONFILE_FAILURE]);

const fromDataToChargeAmount = (data) => (data?.isNoShowFee ? data?.amount : replaceNaN(null, fromAnyToCoinNum(data?.amount)));

const fromDataToIsNoShowFee = (data) =>
  // for deposit, it's true, but for card payment it is 0, not false
  data?.isNoShowFee || 0;

export const beChargeCardOnFileV1 = (options) => ({
  [AUTH_API]: {
    ...authenticatedEndpoint(),
    ...jsonEndpoint(H.post, `ncob/checkout/salon/charge/${options?.salonId}/`, {
      client_id: options?.clientId,
      appointment_id: options?.appointmentId,
      amount_to_charge: fromDataToChargeAmount(options),
      is_no_show_fee: fromDataToIsNoShowFee(options),
    }),
    types: options?.isNoShowFee ? DEPO_TYPES : CARD_TYPES,
    params: options?.isNoShowFee
      ? {
          client_id: options?.clientId,
          appointment_id: options?.appointmentId,
          amount_to_charge: options?.amount,
          depositData: options?.depositData,
          clientHasCard: options?.clientHasCard,
          is_no_show_fee: options?.isNoShowFee,
          noshow_action: isUndefined(options?.noShowAction) ? '' : options?.noShowAction,
        }
      : void 1,
  },
});

const fromDtoToUpdateInfo = (dto) => {
  dto = dto?.results ?? dto;
  return {
    error: dto?.error,
    success: dto?.success,
    paid: dto?.paid,
    paidNormalized: fromAnyToCoinNum(dto?.paid),
  };
};

const fromUpdateDataToDto = (item) => ({
  client_id: item?.clientId,
  appointment_id: item?.appointmentId,
  amount_to_charge: fromDataToChargeAmount(item),
  is_no_show_fee: fromDataToIsNoShowFee(item),
});

const umsgIgnoring404 = (options, context) => {
  // a replacement for UMSG_TYPE.global because after deleting the appointment, we get 404
  if (context?.is?.notFound) {
    return void L.info('umsgIgnoring404()', 'UMSG ignoring not found error for:', { options, context });
  } else {
    const error = context?.json?.error;
    const suffix = error ? `(${error})` : '';
    return `There has been a error charging card on file ${suffix}`;
  }
};

export const ibeChargeCardOnFileV2 = actionEndpointBe('ibeChargeCardOnFileV2', H.post, 'ncob/checkout/salon/charge/:salonId/', (options, extra) => ({
  ...options,
  inert: true,
  isMissingParams: isNotValidId(fromAnyToTrimmed(extra?.appointmentId)) || isNotValidId(fromAnyToTrimmed(extra?.clientId)),
  data: extra,
  fromDto: fromDtoToUpdateInfo,
  toDto: fromUpdateDataToDto,
  umsg: umsgIgnoring404,
}));
